import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Tooltip from 'rc-tooltip'
import './styles/styles.css'

const Hints = (props) => {
  return (
    <Tooltip
      className='hints-tooltip'
      placement='right'
      mouseEnterDelay={0.1}
      mouseLeaveDelay={0.2}
      trigger={['click', 'hover']}
      overlay={<span>{props.message}</span>}
    >
      <label className='checklist-completed-label'>
        <FontAwesomeIcon icon={faInfoCircle} />
      </label>
    </Tooltip>
  )
}

export default Hints
